import React from "react";
import store from "../../../Store";
import getUsers from "../../../ajax/actions/user/users_get";
import { resetUsersParams } from "./UserList-Actions";

class UserWorker extends React.Component {
  componentDidMount() {
    store.dispatch(resetUsersParams());
    store.dispatch(getUsers());
  }

  render() {
    return null;
  }
}

export default UserWorker;
